import { render, staticRenderFns } from "./PublishInfoCard.vue?vue&type=template&id=0c0f97d2&scoped=true"
import script from "./PublishInfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublishInfoCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublishInfoCard.vue?vue&type=style&index=0&id=0c0f97d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f97d2",
  null
  
)

export default component.exports